/** Pixel offset from the modal's laid-out (centred) position. */
export type ModalDragOffset = { x: number; y: number };

/**
 * Clamp an absolute drag offset so the panel (at layout position + offset)
 * keeps at least `edgePx` of itself inside the viewport.
 *
 * `layout` is the panel's getBoundingClientRect with transform removed
 * (rendered.left - currentOffset.x, …).
 */
export function clampModalDragOffset(
  offset: ModalDragOffset,
  layout: { left: number; top: number; width: number; height: number },
  viewport: { width: number; height: number },
  edgePx = 48
): ModalDragOffset {
  let { x, y } = offset;

  const nextLeft = layout.left + x;
  const nextTop = layout.top + y;
  const nextRight = nextLeft + layout.width;
  const nextBottom = nextTop + layout.height;

  if (nextRight < edgePx) x += edgePx - nextRight;
  if (nextLeft > viewport.width - edgePx) x -= nextLeft - (viewport.width - edgePx);

  if (nextBottom < edgePx) y += edgePx - nextBottom;
  if (nextTop > viewport.height - edgePx) y -= nextTop - (viewport.height - edgePx);

  return { x, y };
}

/** Header chrome that must not start a drag (close button, links, …). */
export function isModalDragHandleTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return !target.closest('button, a, input, textarea, select, label, [data-no-drag]');
}
